import styled, { css, keyframes } from 'styled-components'

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
`

export const MessageContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  pointer-events: none;
`

export const MessageItem = styled.div<{ $type: 'info' | 'error' | 'warning'; $visible: boolean }>`
  padding: 10px 16px;
  border-radius: 4px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  animation: ${(props) => (props.$visible ? slideIn : slideOut)} 0.3s ease-in-out;

  ${(props) => {
    switch (props.$type) {
      case 'info':
        return css`
          background-color: #e6f7ff;
          border: 1px solid #91d5ff;
          color: #1890ff;
        `
      case 'error':
        return css`
          background-color: #fff2f0;
          border: 1px solid #ffccc7;
          color: #ff4d4f;
        `
      case 'warning':
        return css`
          background-color: #fffbe6;
          border: 1px solid #ffe58f;
          color: #faad14;
        `
    }
  }}
`
